// extracted by mini-css-extract-plugin
export default {"container":"Resources_container__6MyDc","resourcesCard":"Resources_resourcesCard__5O+mq","img":"Resources_img__kvu19","text":"Resources_text__XqmcX","icon":"Resources_icon__MpuuP"};